var button_identification = document.querySelector(".landingHero__header__layoutbtn__btnLogin");

button_identification.addEventListener('click', function () {
  window.location.href = 'connexion.html';
});